module.exports = __webpack_public_path__ + "static/media/UnitedSansReg-Light.29403b10.eot";